export enum DocGenerationSource {
  FA = 'FA',
  CX = 'CX',
}
